const AdvancedSearchSection = ({ label, children }) => {
  return (
    <div className="spo-m-advanced-search-section">
      {label && <h5 className="u-margin-bottom-xs">{label}</h5>}
      <div className="row">{children}</div>
    </div>
  );
};

export default AdvancedSearchSection;
